export default "__VITE_ASSET__f0b587a5__"